export const SUPPORT_URLS = {
  PRODUCT_PAGE: {
    TAG_INSTRUCTIONS:
      'https://support.prettydamnquick.com/en/articles/7953892-adding-a-delivery-promise-to-the-product-page',
    BLOCK_INSTRUCTIONS:
      'https://support.prettydamnquick.com/en/articles/8851501-installing-product-page-delivery-promise-with-online-store-2-0-using-theme-blocks',
  },
};

export const ROUTE_URLS = {
  CHECKOUT_SETTINGS: '/settings/checkout',
};
